import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import LazyLoad from 'react-lazyload';
import { AppNoInfo, AppRemixIcon } from '@/layout/AppComponents';
import BreadcrumbHandler from '../../../layout/components/breadcrumb/BreadcrumbHandler';
import useIsMounted from '../../../layout/components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';
import { axiosPath, path } from '../../../routing/helpers/router';
import * as currentPageAction from '../../../store/actions/currentPageAction';
import Translator from '../../../layout/components/helpers/Translator';
import ElementContainer from '../../../layout/screenSpecifics/Modules/ResourceManager/ElementContainer';
import ResourceManagerSidebar from '../../../layout/screenSpecifics/Modules/ResourceManager/Sidebar/ResourceManagerSidebar';
import GCLPaginator from '../../../layout/screenSpecifics/Modules/LegalCompliance/Evaluation/GCLPaginator';
import * as moduleAction from '../../../store/actions/moduleAction';

export default function ModuleResourceManagerObligationHomeScreen() {
  const { moduleBridgeHex, filtersHex, page } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const navigate = useNavigate();
  const moduleData = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.moduleData,
  );
  const resourceObligationsPage = useSelector(
    (state) => state.currentPage?.resourceObligationsPage,
  );
  const obLevel1 = useSelector(
    (state) => state.currentPage?.resourceObligationLevels?.level1,
  );
  const obLevel2 = useSelector(
    (state) => state.currentPage?.resourceObligationLevels?.level2,
  );
  const [loading, setLoading] = useState(true);
  const [obligations, setObligations] = useState(null);

  useEffect(() => {
    dispatch(currentPageAction.change('view', 'obligation'));

    return () => {
      dispatch(currentPageAction.empty());
    };
  }, []);

  // PARA CAMBIAR A FUTURO A COMPONENTE O SIMILAR
    if (!moduleBridgeHex || !moduleData) {
      <AppNoInfo />;
    }
    // > LOAD MODULE DATA //
    const loadModuleData = useCallback(async () => {
      dispatch(
        moduleAction.fetch(
          axiosPath('api_r_user_module_resourceManager_getModuleData'),
          'moduleData',
          {
            moduleBridgeHex,
          },
        ),
      );
    }, []);
  
    useEffect(() => {
        !moduleData && loadModuleData();
      }, []);
    // > LOAD MODULE DATA //
    // < STORE CALLS
    const loadModulePermissions = useCallback(async () => {
      try {
        await dispatch(
          moduleAction.fetch(
            axiosPath('api_r_user_module_resourceManager_getPermissions'),
            'permissions',
            {
              moduleBridgeHex,
              subType: 'permissions',
            },
          ),
        );
        await dispatch(
          moduleAction.fetch(
            axiosPath('api_r_user_module_resourceManager_getPermissions'),
            'userBridge',
            {
              moduleBridgeHex,
              subType: 'userBridge',
            },
          ),
        );
      } catch (err) {}
    }, [moduleBridgeHex]);
  
    useEffect(() => {
      loadModulePermissions();
    }, [moduleBridgeHex]);
    // < STORE CALLS

  // > LOAD OBLIGATIONS
  const loadResourceObligations = useCallback(
    async () =>
      axios
        .post(
          axiosPath(
            'api_r_user_module_resourceManager_resourceObligation_list',
          ),
          {
            moduleBridgeHex,
            filtersHex,
            view: 'obligation',
          },
        )
        .then(({ data }) => {
          if (isMounted.current) {
            setObligations(data);
            dispatch(
              currentPageAction.change('resman', {
                resourceObligations: data.elementIDs,
              }),
            );
            dispatch(currentPageAction.change('pagination', data.pagination));
            dispatch(
              currentPageAction.change(
                'resourceObligationsPage',
                data.elementIDs,
                true,
              ),
            );
          }
        })
        .catch((e) => dispatch(errorHandler(e))),
    [moduleBridgeHex, filtersHex, page],
  );

  useEffect(() => {
    setLoading(true);
    loadResourceObligations();
  }, [filtersHex]);
  // < LOAD OBLIGATIONS

  // > LOAD OBLIGATION LEVELS
  const loadObLevel = async (level) =>
    axios.post(
      axiosPath('api_r_user_module_resourceManager_resourceObligation_level'),
      {
        moduleBridgeHex,
        elementIDs: obligations?.elementIDs?.[page - 1],
        level,
        view: 'obligation',
      },
    );

  // Level 1
  useEffect(() => {
    if (obligations?.elementIDs) {
      setLoading(false);
      window.scrollTo(0, 0);
      if (obligations?.elementIDs.length > 0) {
        loadObLevel(1).then((obLvl1) => {
          dispatch(
            currentPageAction.change(
              'elementLevels',
              {
                level1: !obLevel1
                  ? obLvl1?.data
                  : { ...obLevel1, ...obLvl1?.data },
              },
              true,
            ),
          );
          loadObLevel(2).then((obLvl2) => {
            dispatch(
              currentPageAction.change('elementLevels', {
                level2: !obLevel2
                  ? obLvl2?.data
                  : { ...obLevel2, ...obLvl2?.data },
              }),
            );
          });
        });
      }
    }
  }, [obligations, page]);
  // < LOAD OBLIGATION LEVELS

  return (
    <>
      <ResourceManagerSidebar activeRoute="user_module_resourceManager_obligation_home" />
      <BreadcrumbHandler
        paths={
          moduleData
            ? [{ name: `${moduleData?.moduleName}` }]
            : [{ name: '...' }]
        }
      />
      <main role="main" className="col-md-12 col-lg-12 px-md-4 mb-5">
        <div className="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-0 pb-0 mb-0">
          {filtersHex !== '0' && (
            <div className="alert alert-info pointer">
              <span
                onClick={() =>
                  navigate(
                    path({
                      name: 'user_module_resourceManager_obligation_home',
                      params: {
                        moduleBridgeHex,
                        page: 1,
                        filtersHex: '0',
                      },
                    }),
                  )
                }
              >
                <AppRemixIcon icon="delete-bin-6" className="mr-2" />
                <Translator file="filter" name="filter.delete" />
              </span>
              <span
                className="ml-4"
                onClick={() =>
                  dispatch(
                    currentPageAction.change('auxSidebar', {
                      opened: 'filters',
                    }),
                  )
                }
              >
                <AppRemixIcon icon="equalizer" className="mr-2" />
                <Translator file="module-legalCompliance" name="show.filters" />
              </span>
            </div>
          )}
          {loading ? (
            <AppNoInfo minHeight={window.innerHeight - 60} />
          ) : obligations.elementIDs && obligations.elementIDs.length > 0 ? (
            obligations.elementIDs?.[page - 1].map((roID, i) => (
              <LazyLoad key={i} height={113}>
                <ElementContainer view="obligation" elementID={roID} />
              </LazyLoad>
            ))
          ) : (
            <div className="alert alert-info">
              <Translator file="module-resourceManager" name="no.obligations" />
            </div>
          )}
        </div>
        {resourceObligationsPage?.length > 0 && obligations && (
          <GCLPaginator
            pagination={obligations?.pagination}
            route="user_module_resourceManager_obligation_home"
            page={page}
            plantObligationPages={resourceObligationsPage}
            itemsPerPage={20}
            className="mt-3"
            params={{
              moduleBridgeHex,
              page,
              filtersHex,
            }}
          />
        )}
      </main>
    </>
  );
}
